
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement("path", { d: "m57.6 13.7c-.7-1-1.6-1.7-2.7-2.2-3.4-1.7-11.6-1.3-12.3-5.7-.9-5.7-5.9.1-6.8.1-1.1 0-1.6-3.9-3.7-3.9-2.2 0-2.7 3.9-3.7 3.9-.9 0-5.9-5.8-6.8-.1-.7 4.3-9 4-12.3 5.7-1 .5-2 1.2-2.7 2.2-.5.8.6 1.6 1.2.9 1.6-2 4.8-2.4 7.1-2.8 1.9-.4 4-.6 5.9-1.4 2.6-1 2.5-4.9 3.3-4.9.6 0 2.7 3 4.5 3 1.6 0 2.6-3.7 3.5-3.7.9 0 1.9 3.7 3.5 3.7 1.9 0 4-3 4.6-3 .8 0 .7 3.9 3.3 4.9 1.8.8 3.9 1 5.9 1.4 2.3.5 5.6.8 7.1 2.8.5.7 1.6-.2 1.1-.9", fill: "#00b9f1" }),
	React.createElement("path", { d: "M53,57c0,2.8-2.2,5-5,5H16c-2.8,0-5-2.2-5-5V36h42V57z", fill: "#89967a" }),
	React.createElement("path", { d: "m32 12c-15.5 0-21 8.5-21 24v21h42v-21c0-15.5-5.5-24-21-24", fill: "#b6c4a7" }),
	React.createElement(
		"g",
		{ fill: "#89967a" },
		React.createElement("path", { d: "m11 55c-1.1 0-2-1.2-2-2.6v-6.8c0-1.4.9-2.6 2-2.6v12" }),
		React.createElement("path", { d: "m53 43c1.1 0 2 1.2 2 2.6v6.8c0 1.4-.9 2.6-2 2.6v-12" })
	),
	React.createElement(
		"g",
		{ fill: "#3e4347" },
		React.createElement("path", { d: "m7 20h-2v30h2 2v-2h-2z" }),
		React.createElement("path", { d: "m57 20v28h-2v2h2 2v-30z" })
	),
	React.createElement("circle", { cx: "58", cy: "20", fill: "#00b9f1", r: "4" }),
	React.createElement(
		"g",
		null,
		React.createElement("circle", { cx: "6", cy: "20", fill: "#ff5263", r: "4" })
	),
	React.createElement("path", { d: "m21.5 39.5c-4.4 0-8-3.6-8-8 0-4.4 3.6-8 8-8 4.4 0 8 3.6 8 8 0 4.4-3.6 8-8 8", fill: "#efffd9" }),
	React.createElement("circle", { cx: "21.5", cy: "31.5", fill: "#545b61", r: "6" }),
	React.createElement("circle", { cx: "21.5", cy: "31.5", fill: "#ff5263", r: "2.3" }),
	React.createElement("path", { d: "m42.5 39.5c-4.4 0-8-3.6-8-8 0-4.4 3.6-8 8-8 4.4 0 8 3.6 8 8 0 4.4-3.6 8-8 8", fill: "#efffd9" }),
	React.createElement("path", { d: "m42.5 37.5c-3.3 0-6-2.7-6-6 0-3.3 2.7-6 6-6 3.3 0 6 2.7 6 6 0 3.3-2.7 6-6 6", fill: "#545b61" }),
	React.createElement("circle", { cx: "42.5", cy: "31.5", fill: "#ff5263", r: "2.3" }),
	React.createElement("path", { d: "m19.8 54.1c-7.4 0-7.4-13 0-13h24.5c7.4 0 7.4 13 0 13h-24.5", fill: "#efffd9" }),
	React.createElement("path", { d: "m20.5 52.6c-6 0-6-10 0-10h23c6 0 6 10 0 10h-23", fill: "#89967a" }),
	React.createElement(
		"g",
		{ fill: "#3e4347", opacity: ".7" },
		React.createElement("path", { d: "m21.2 50.7c0 1.2-2 1.2-2 0v-6.1c0-1.2 2-1.2 2 0v6.1" }),
		React.createElement("path", { d: "m25.9 50.7c0 1.2-2 1.2-2 0v-6.1c0-1.2 2-1.2 2 0v6.1" }),
		React.createElement("path", { d: "m30.6 50.7c0 1.2-2 1.2-2 0v-6.1c0-1.2 2-1.2 2 0v6.1" }),
		React.createElement("path", { d: "m35.4 50.7c0 1.2-2 1.2-2 0v-6.1c0-1.2 2-1.2 2 0v6.1" }),
		React.createElement("path", { d: "m40.1 50.7c0 1.2-2 1.2-2 0v-6.1c0-1.2 2-1.2 2 0v6.1" }),
		React.createElement("path", { d: "m44.8 50.7c0 1.2-2 1.2-2 0v-6.1c0-1.2 2-1.2 2 0v6.1" })
	),
	React.createElement("circle", { cx: "32", cy: "37", fill: "#f5f5f5", r: "2" }),
	React.createElement("path", { d: "m31.6 35h.8v4h-.8z", fill: "#545b61", transform: "matrix(.7071-.7071.7071.7071-16.7765 33.4583)" })
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/robot.js
// module id = 717
// module chunks = 0